"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionResult = exports.isValidExpression = exports.compile = exports.default = void 0;
const constant_1 = require("./constant");
Object.defineProperty(exports, "ConditionResult", { enumerable: true, get: function () { return constant_1.ConditionResult; } });
var api_1 = require("./api");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(api_1).default; } });
Object.defineProperty(exports, "compile", { enumerable: true, get: function () { return api_1.compile; } });
Object.defineProperty(exports, "isValidExpression", { enumerable: true, get: function () { return api_1.isValidExpression; } });
__exportStar(require("./types"), exports);
